import { httpCommonAuth } from "../http.service";

const API_PATH = "/files";

export const downloadFile = (fileName) =>
  httpCommonAuth.get(`${API_PATH}/download/${fileName}`, {
    responseType: "arraybuffer",
  });

export const uploadFolderStructure = (formData, onProgress) => {
  return httpCommonAuth.post(`${API_PATH}/uploadfolderstructure/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: (progressEvent) => {
      const percentage = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      // Trigger the callback with the current progress
      if (onProgress) {
        onProgress(percentage);
      }
    },
  });
};

export const uploadFileAxios = (formData, fileId) => {
  return httpCommonAuth.post(`${API_PATH}/uploadfile/${fileId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Rolls back a just-created filedata whose file upload failed, so no orphan
// metadata record is left behind. Server only deletes it if it is a brand-new
// orphan owned by the current user.
export const rollbackNewFileDataAxios = (fileId) =>
  httpCommonAuth.delete(`${API_PATH}/filedata/${fileId}`);

export const uploadTenantLogoAxios = (formData, tenantId) => {
  return httpCommonAuth.post(`tenant/upload-logo/${tenantId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const uploadNewsImageAxios = (newsId, file) => {
  const formData = new FormData(); // Erstellen eines FormData-Objekts
  formData.append("file", file); // Datei unter dem Namen "file" anhängen

  return httpCommonAuth.post(`news/upload-news-image/${newsId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const uploadNewsDocumentAxios = (newsId, file) => {
  const formData = new FormData(); // Erstellen eines FormData-Objekts
  formData.append("file", file); // Datei unter dem Namen "file" anhängen

  return httpCommonAuth.post(`news/upload-news-document/${newsId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const uploadLawDocumentAxios = (lawId, file) => {
  const formData = new FormData(); // Erstellen eines FormData-Objekts
  formData.append("file", file); // Datei unter dem Namen "file" anhängen

  return httpCommonAuth.post(`laws/upload-laws-document/${lawId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const checkOutFileByID = (fileDataId, options = {}) => {
  const params = options?.recallTemp ? { recallTemp: true } : undefined;
  return httpCommonAuth.get(`/filedata/checkOutFileByID/${fileDataId}`, {
    responseType: "arraybuffer",
    params,
    headers: options?.sessionId
      ? { "x-filedata-session-id": options.sessionId }
      : undefined,
  });
};

export const uploadRecallTempFileAxios = (formData, fileId) => {
  return httpCommonAuth.post(`/filedata/recall-temp/${fileId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const checkInFileByID = (fileDataId, options = {}) =>
  httpCommonAuth.put(
    `/filedata/checkInFileByID/${fileDataId}`,
    {
      checkedOutSessionId: options?.sessionId,
      force: options?.force,
    },
    {
      headers: options?.sessionId
        ? { "x-filedata-session-id": options.sessionId }
        : undefined,
    }
  );

export const unlockFileDataByID = (fileDataId) =>
  httpCommonAuth.patch(`/filedata/${fileDataId}/unlock`);

export const downloadFileByID = (fileDataId) =>
  httpCommonAuth.get(`/filedata/downloadFileByID/${fileDataId}`, {
    responseType: "arraybuffer",
  });

export const downloadConvertedPdfFileByID = (fileDataId) =>
  httpCommonAuth.get(`/filedata/downloadConvertedPdfFileByID/${fileDataId}`, {
    responseType: "arraybuffer",
  });
